import React from 'react';
import PropTypes from 'prop-types';
import TimeEntryItem from '../timeEntryItem';

import './style.sass';

const getPrevIdResultByIndex = (result, index) => (index !== 0 ? result[index - 1] : null);

const TimeEntryHistory = ({ timeEntriesList, onEdit, onDelete }) => (
  <div className="time-entry__history">
    {
      timeEntriesList && timeEntriesList.length ? (
        timeEntriesList.map((id, index) => (
          <TimeEntryItem
            key={id}
            onDelete={onDelete}
            onEdit={onEdit}
            id={id}
            prevId={getPrevIdResultByIndex(timeEntriesList, index)}
          />
        ))
      ) : <div className="task-timeEntry__empty">There are no time entries yet</div>
    }
  </div>
);

TimeEntryHistory.propTypes = {
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  timeEntriesList: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export default TimeEntryHistory;
